export function layoutDSL(strings, ...values) {
  const raw = String.raw(strings, ...values);

  // ------------------------------------------------------------
  // 1. Normalize lines
  // ------------------------------------------------------------
  const lines = raw
    .split("\n")
    .map((l) => l.trim())
    .filter((l) => l.length > 0 && !l.startsWith("//"));

  // ------------------------------------------------------------
  // 2. Split into sections
  // ------------------------------------------------------------
  const sections = {};
  let current = null;

  for (const line of lines) {
    if (line.endsWith(":")) {
      current = line.slice(0, -1).trim();
      sections[current] = [];
    } else if (current) {
      sections[current].push(line);
    }
  }

  // ------------------------------------------------------------
  // 3. Parse grid
  // ------------------------------------------------------------
  const grid = { cols: 1, rows: 1 };

  if (sections.grid) {
    for (const line of sections.grid) {
      const idx = line.indexOf(":");
      if (idx === -1) continue;

      const key = line.slice(0, idx).trim();
      const val = line.slice(idx + 1).trim();
      grid[key] = Number(val);
    }
  }

  // ------------------------------------------------------------
  // 4. Parse areas (2D matrix)
  // ------------------------------------------------------------
  let areas = [];

  if (sections.areas) {
    areas = sections.areas.map((row) =>
      row.split(/\s+/).map((cell) => cell.trim()),
    );
  }

  // ------------------------------------------------------------
  // 5. Parse slots (strict JSON)
  // ------------------------------------------------------------
  const slots = {};

  if (sections.slots) {
    for (const line of sections.slots) {
      const idx = line.indexOf(":");
      if (idx === -1) continue;

      const name = line.slice(0, idx).trim();
      const json = line.slice(idx + 1).trim();

      // strict JSON only
      slots[name] = JSON.parse(json);
    }
  }

  // ------------------------------------------------------------
  // 6. FIX: Ensure repeated area names map to the same slot
  // ------------------------------------------------------------
  for (const row of areas) {
    for (const cell of row) {
      if (!slots[cell]) {
        // default slot if not explicitly defined
        slots[cell] = { index: 0 };
      }
    }
  }

  // ------------------------------------------------------------
  // 7. Parse weight
  // ------------------------------------------------------------
  let weight = 1;

  if (sections.weight) {
    for (const line of sections.weight) {
      const idx = line.indexOf(":");
      if (idx === -1) continue;

      const key = line.slice(0, idx).trim();
      const val = line.slice(idx + 1).trim();

      if (key === "weight") {
        weight = Number(val);
      }
    }
  }

  // ------------------------------------------------------------
  // 8. Return parsed DSL object
  // ------------------------------------------------------------
  return {
    grid,
    areas,
    slots,
    weight,
  };
}
